import { RouteObject } from 'react-router-dom';

import { AppNotFoundPage } from '@/components';

import { actionsRoute } from '../features/action-settings/routes';
import { companyProfileRoute } from '../features/company-profile/routes';
import { engageSettingsRoute } from '../features/engage-settings/routes';
import { globalLetterSettingsRoute } from '../features/global-letter-settings/routes';
import { integrationsRoute } from '../features/integrations/routes';
import { subscriptionsRoute } from '../features/subscriptions/routes';
import { userProfileRoute } from '../features/user-profile/routes';
import { userSettingsRoute } from '../features/user-settings/routes';

export const settingRoutes: RouteObject = {
  path: '/settings',
  children: [
    actionsRoute,
    engageSettingsRoute,
    companyProfileRoute,
    userSettingsRoute,
    globalLetterSettingsRoute,
    integrationsRoute,
    companyProfileRoute,
    userProfileRoute,
    subscriptionsRoute,
    { path: '*', element: <AppNotFoundPage path=".." /> },
  ],
};
